import connect from 'react-redux/es/connect/connect';

import ReviewPage from './ReviewPage';
import {
    updateItemGuest,
    acceptBookingNote,
    setAgentNote,
    setHasCustomBooking,
    addAddon,
    updateCartItem
} from '../../actions/cart';
import { createGuest } from '../../actions/user';

const mapStateToProps = state => {
    return {
        cartItems: state.cart.cartItems,
        booker: state.cart.booker,
        customer: state.user.customer,
        user: state.user.user
    };
};

const mapDispatchToProps = dispatch => ({
    updateItemGuest: (itemIndex, ticketId, guestIndex, guest) => {
        dispatch(updateItemGuest(itemIndex, ticketId, guestIndex, guest));
    },
    acceptBookingNote: cartitemIndex => {
        dispatch(acceptBookingNote(cartitemIndex));
    },
    setAgentNote: (cartitemIndex, agentnote) => {
        dispatch(setAgentNote(cartitemIndex, agentnote));
    },
    setHasCustomBooking: (cartitemIndex, hasCustomBooking) => {
        dispatch(setHasCustomBooking(cartitemIndex, hasCustomBooking));
    },
    addAddon: (cartItemId, addons) => {
        dispatch(addAddon(cartItemId, addons));
    },
    updateCartItem: (cartItemIndex, cartItem) => {
        dispatch(updateCartItem(cartItemIndex, cartItem));
    },
    createGuest: (
        firstname,
        lastname,
        phone,
        email,
        additional_emails,
        guest_field_info,
        arrival_date,
        departure_date,
        internal_notes,
        notification,
        source_id,
        onSuccess,
        onError
    ) => {
        dispatch(
            createGuest({
                firstname,
                lastname,
                phone,
                email,
                additional_emails,
                guest_field_info,
                arrival_date,
                departure_date,
                internal_notes,
                notification,
                source_id,
                onSuccess,
                onError
            })
        );
    }
});

export default connect(mapStateToProps, mapDispatchToProps)(ReviewPage);
